const introBtn = document.querySelector('.intro-video__btn');
const introFade = document.querySelector('.intro-video__fade');
const introVideo = document.querySelector('.intro-video__video');
const home = document.querySelector('.home');
const logo = document.querySelector('.home__logo');
const homeTitle = document.querySelector('.home__title');
const homeContent = document.querySelector('.home__right-content');
const homeBtns = document.querySelectorAll('.home__right-item');
const homeRight = document.querySelector('.home__right');
const homeLeft = document.querySelector('.home__left');
const submenu = document.querySelector('.submenu');
const submenuLinks = document.querySelector('.submenu__links');
const materialsBtn = document.querySelector('.materials-btn');
const materials = document.querySelector('.materials');
const submenuBack = document.querySelector('.submenu__back');
const startPicker = document.querySelector('.start-picker');
const materialItems = document.querySelectorAll('.materials__item');
const endPicker = document.querySelector('.end-picker');
const inputScreen = document.querySelector('.input-screen');
const openSecondModal = document.querySelector('.open-second-modal');
const secondModal = document.querySelector('.second-modal');
const firstModal = document.querySelector('.first-modal');
const openFile = document.querySelector('.open-file');
const closeModals = document.querySelectorAll('.close-modal');
const closeVideo = document.querySelector('.close-video');
const fileScreen = document.querySelector('.file-screen');

introBtn.addEventListener('click', () => {
  introBtn.classList.add('hidden');
  introFade.classList.add('active');
  introVideo.classList.add('zoom');

  setTimeout(() => {
    introVideo.pause();
    home.classList.add('active');
  }, 1000);

  setTimeout(() => {
    homeContent.classList.add('show');
  }, 1500);
});

homeBtns.forEach((homeBtn) => {
  homeBtn.addEventListener('click', () => {
    homeLeft.classList.add('hidden');
    homeRight.classList.add('active');

    setTimeout(() => {
      submenuLinks.classList.add('active');
    }, 1500);
  });
});

materialsBtn.addEventListener('click', () => {
  submenu.classList.toggle('blurred');
  materials.classList.toggle('active');
});

submenuBack.addEventListener('click', () => {
  homeLeft.classList.remove('hidden');
  homeRight.classList.remove('active');
  submenuLinks.classList.remove('active');
});

startPicker.addEventListener('click', () => {
  materialItems.forEach((materialItem) => {
    materialItem.classList.add('pick');
    materialItem.addEventListener('click', () => {
      materialItem.classList.toggle('picked');
    });
  });

  startPicker.classList.add('d-none');
  endPicker.classList.add('show');
});

endPicker.addEventListener('click', () => {
  inputScreen.classList.add('active');
  firstModal.classList.add('slide-down');
  materials.classList.remove('active');
});

openSecondModal.addEventListener('click', () => {
  firstModal.classList.add('slide-up');
  firstModal.classList.remove('slide-down');

  setTimeout(() => {
    secondModal.classList.add('slide-down');
  }, 200);

  setTimeout(() => {
    firstModal.classList.remove('slide-up');
  }, 600);
});

openFile.addEventListener('click', () => {
  secondModal.classList.add('slide-up');

  setTimeout(() => {
    fileScreen.classList.add('active');
  }, 300);

  setTimeout(() => {
    secondModal.classList.remove('slide-up');
    secondModal.classList.remove('slide-down');
    fileScreen.querySelector('.file-screen__video').play();
  }, 600);
});

closeModals.forEach((closeModal) => {
  closeModal.addEventListener('click', () => {
    closeModal.closest('.input-screen__modal').classList.add('slide-up');
    setTimeout(() => {
      closeModal.closest('.input-screen__modal').classList.remove('slide-up');
      closeModal.closest('.input-screen__modal').classList.remove('slide-down');
    }, 600);
    inputScreen.classList.remove('active');
    submenu.classList.remove('blurred');
  });
});

closeVideo.addEventListener('click', () => {
  fileScreen.classList.remove('active');
  fileScreen.querySelector('.file-screen__video').pause();
  inputScreen.classList.remove('active');
  inputScreen.classList.remove('active');
  submenu.classList.remove('blurred');
});
